import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import HomeView from "../views/HomeView.vue";
import Account from "@/views/Account.vue";
import Empty from "@/views/empty.vue";

Vue.use(VueRouter);

export enum RoleType {
  Admin = "admin",
  Normal = "ordinary",
}

export const modules: Array<any> = [
  {
    path: "user",
    name: "user",
    icon: "icon-yonghuguanli",
    role: [RoleType.Admin],
    meta: { title: "用户" },
    title: "用户",
    component: () => import("../views/user/user.vue"),
  },
  {
    path: "version",
    name: "version",
    icon: "icon-banben",
    role: [RoleType.Admin],
    meta: { title: "版本" },
    title: "版本",
    component: () => import("../views/version/version.vue"),
  },
  {
    path: "resource",
    name: "resource",
    icon: "icon-ziyuan",
    role: [RoleType.Admin, RoleType.Normal],
    meta: { title: "资源" },
    title: "资源",
    component: () => import("../views/resource/resource.vue"),
  },
  {
    path: "courseware",
    name: "courseware",
    icon: "icon-kejian",
    role: [RoleType.Admin, RoleType.Normal],
    meta: { title: "课件" },
    title: "课件",
    component: () => import("../views/courseware/courseware.vue"),
  },
  {
    path: "experiment",
    name: "experiment",
    icon: "icon-shiyan",
    role: [RoleType.Admin, RoleType.Normal],
    meta: { title: "实验" },
    title: "实验",
    component: () => import("../views/experiment/experiment.vue"),
  },
  {
    path: "question",
    name: "question",
    icon: "icon-xiti",
    role: [RoleType.Admin, RoleType.Normal],
    meta: { title: "习题" },
    title: "习题",
    component: () => import("../views/question/question.vue"),
  },
  {
    path: "case",
    name: "case",
    icon: "icon-bingli",
    role: [RoleType.Admin, RoleType.Normal],
    meta: { title: "案例" },
    title: "案例",
    component: () => import("../views/case/case.vue"),
  },
  //   {
  //   path: "knowledge",
  //   name: "knowledge",
  //   icon: "icon-bingli",
  //   role: [RoleType.Admin, RoleType.Normal],
  //   meta: { title: "图谱" },
  //   title: "图谱",
  //   component: () => import("../views/knowledge/knowledge.vue"),
  // },
  {
    path: "more",
    name: "more",
    icon: "icon-gengduo",
    role: [RoleType.Admin, RoleType.Normal],
    meta: { title: "更多" },
    title: "更多",
    component: Empty,
    children: [
      {
        path: "/home/encryption",
        name: "encryption",
        icon: "icon-jiami",
        role: [RoleType.Admin],
        meta: { title: "加密" },
        title: "加密",
        component: () => import("../views/encryption/encryption.vue"),
      },
      {
        path: "/home/questionType",
        name: "questionType",
        icon: "icon-fangan",
        role: [RoleType.Admin, RoleType.Normal],
        meta: { title: "题型" },
        title: "题型",
        component: () => import("../views/questionType/questionType.vue"),
      },
      // {
      //   path: "/home/graphTag",
      //   name: "graphTag",
      //   icon: "icon-fangan",
      //   role: [RoleType.Admin, RoleType.Normal],
      //   meta: { title: "图谱标签" },
      //   title: "图谱标签",
      //   component: () => import("../views/graphTag/graphTag.vue"),
      // },
      {
        path: "/home/suit",
        name: "suit",
        icon: "icon-shiyongduixiang",
        role: [RoleType.Admin, RoleType.Normal],
        meta: { title: "适用对象" },
        title: "适用对象",
        component: () => import("../views/suitPeople/suitPeople.vue"),
      },
      {
        path: "/home/lang",
        name: "lang",
        icon: "icon-yuyan",
        role: [RoleType.Admin],
        meta: { title: "语言" },
        title: "语言",
        component: () => import("../views/lang/lang.vue"),
      },
      {
        path: "/home/channel",
        name: "channel",
        icon: "icon-qudao",
        role: [RoleType.Admin, RoleType.Normal],
        meta: { title: "获取渠道" },
        title: "获取渠道",
        component: () => import("../views/channel/channel.vue"),
      },
      {
        path: "/home/platform",
        name: "platform",
        icon: "icon-xitong",
        role: [RoleType.Admin],
        meta: { title: "系统平台" },
        title: "系统平台",
        component: () => import("../views/platform/platform.vue"),
      },
      {
        path: "/home/discipline",
        name: "discipline",
        icon: "icon-xueke",
        role: [RoleType.Admin, RoleType.Normal],
        meta: { title: "学科" },
        title: "学科",
        component: () => import("../views/discipline/discipline.vue"),
      },
    ],
  },
];

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "account",
    meta: { title: "登录" },
    component: Account,
  },
  {
    path: "/home",
    name: "home",
    component: HomeView,
    redirect: { name: "user" },
    children: modules,
  },
  {
    path: "/specimen",
    name: "specimen",
    meta: { title: "specimen" },
    component: () => import("../components/specimen/singleSpec.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const isLogin = () => {
  return window.localStorage.getItem("Authorization");
};

router.beforeEach((to, from, next) => {
  if (to.name !== "account" && !isLogin()) {
    localStorage.removeItem("Authorization");
    localStorage.removeItem("loginName");
    localStorage.removeItem("roleTypeKeys");
    document.title = to.meta?.title + "-数据维护工具";
    next({ name: "account" });
    // next();
  } else {
    document.title = to.meta?.title + "-数据维护工具";
    next();
  }
});

export default router;
